"use client";

import { ShippingSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedShippingSection from "../Components/GeneratedShippingSection";

const Shipping: FC<ShippingSectionProps> = (props) => {
  return <GeneratedShippingSection {...props} />;
};

export default Shipping;
